export type StatusCelula =
  | "pendencia"
  | "atestado"
  | "concluido"
  | "atrasado"
  | "execucao"
  | "previsto"
  | "nao_iniciado";

export function clampPct(n: unknown): number {
  const v = Number(n);
  if (!Number.isFinite(v)) return 0;
  return Math.min(100, Math.max(0, v));
}

export function getStatusCelula(input: {
  percentualReal: number;
  percentualPrevistoAteMedicaoAtual: number | null;
  percentualPrevistoMedicaoSelecionada: number | null;
  percentualAtestado: number | null;
  pendencia: boolean;
  toleranciaAtrasoPp?: number;
}): StatusCelula {
  const real = clampPct(input.percentualReal);
  const tol = Math.max(0, Number(input.toleranciaAtrasoPp) || 0);
  if (input.pendencia) return "pendencia";
  const atestado =
    input.percentualAtestado == null ? null : clampPct(input.percentualAtestado);
  if (real === 100 && atestado === 100) return "atestado";
  if (real === 100) return "concluido";
  const previstoAtual =
    input.percentualPrevistoAteMedicaoAtual == null
      ? null
      : clampPct(input.percentualPrevistoAteMedicaoAtual);
  if (previstoAtual != null && previstoAtual > 0 && real < previstoAtual - tol) {
    return "atrasado";
  }
  if (real > 0 && real < 100) return "execucao";
  const previstoSel =
    input.percentualPrevistoMedicaoSelecionada == null
      ? null
      : clampPct(input.percentualPrevistoMedicaoSelecionada);
  if (real === 0 && previstoSel != null && previstoSel > 0) return "previsto";
  return "nao_iniciado";
}

export function shortEapCode(
  svc: { id: string; code?: string; parentId?: string },
  catalog: { id: string; code?: string; isGroup?: boolean; parentId?: string }[],
): string {
  const group = catalog.find((s) => s.id === svc.parentId);
  const raw = (group?.code ?? svc.code ?? "0").split(".")[0] ?? "0";
  const groupNum = raw.replace(/^0+/, "") || "0";
  const siblings = catalog.filter((s) => !s.isGroup && s.parentId === svc.parentId);
  const idx = Math.max(1, siblings.findIndex((s) => s.id === svc.id) + 1);
  return `${groupNum}.${String(idx).padStart(2, "0")}`;
}

export function shortServiceName(name: string): string {
  return name.includes(" — ") ? name.split(" — ").slice(1).join(" — ") : name;
}

export function formatMedicaoRange(inicio: string | null, fim: string | null): string {
  if (!inicio || !fim) return "";
  const a = inicio.split("-");
  const b = fim.split("-");
  if (a.length !== 3 || b.length !== 3) return `${inicio} a ${fim}`;
  return `${a[2]}/${a[1]} a ${b[2]}/${b[1]}`;
}

export function formatWhen(iso: string | undefined | null): string {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit" });
}

export const PENDENCIA_MOTIVO_LABELS: Record<string, string> = {
  retrabalho: "Retrabalho",
  reprovado_vistoria: "Reprovado em vistoria",
  bloqueado_predecessor: "Bloqueado por predecessor",
  falta_material: "Falta de material",
  outro: "Outro",
};

export const STATUS_CELULA_LABELS: Record<StatusCelula, string> = {
  pendencia: "Pendência",
  atestado: "Atestado",
  concluido: "Concluído",
  atrasado: "Atrasado",
  execucao: "Em execução",
  previsto: "Previsto na medição",
  nao_iniciado: "Não iniciado",
};
